import {
    Component,
    OnInit,
    AfterViewInit,
    ElementRef,
    ViewChild,
    Input,
    Output,
    EventEmitter,
    OnChanges,
} from "@angular/core";
import { Router } from "@angular/router";
import MetisMenu from "metismenujs";
import { AuthenticationService } from "src/app/_services";
import { AppConfigService } from "src/app/_services/appConfigService";
import { canUploadOnBehalf } from "src/app/_app-core/upload-on-behalf";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() isCondensed = false;
    @Input() options: any = {};
    @Output() mobileMenuButtonClicked = new EventEmitter();
    @Output() settingsButtonClicked = new EventEmitter();
    menu: any;
    menuItems = [];
    openMobileMenu: boolean;
    currentUserPermission;
    canUploadOnBehalf = false;
    showOnBehalfReports = false;

    @ViewChild("sideMenu", { static: false })
    sideMenu?: ElementRef<HTMLElement>;

    constructor(
        private authService: AuthenticationService,
        private router: Router
    ) {}

    ngOnInit() {
        const permissions =
            this.authService.currentUserData?.loginData?.user
                ?.eippSessionData?.data?.user?.permissions || [];
        this.currentUserPermission = permissions.includes("Admin")
            ? "Admin"
            : "Basic";
        this.canUploadOnBehalf = canUploadOnBehalf(
            permissions,
            this.authService.currentUserData?.adminUploadOnBehalf
        );
        this.showOnBehalfReports =
            this.authService.currentUserData?.adminOnBehalfReports === true;
        // this.getMenuItems();
    }

    private setMenu() {
        setTimeout(() => {
            this.menu = new MetisMenu("#side-menu");
        }, 100);
        this._activateMenuDropdown();
    }

    ngAfterViewInit() {
        this.setMenu();
    }

    ngOnChanges() {
        if (!this.isCondensed && this.sideMenu) {
            this.setMenu();
        } else if (this.menu) {
            this.menu.dispose();
        }
    }

    /**
     * Activates the menu dropdown
     */
    _activateMenuDropdown() {
        const links = document.getElementsByClassName("side-nav-link-ref");
        let menuItemEl = null;
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < links.length; i++) {
            // tslint:disable-next-line: no-string-literal
            if (window.location.pathname === links[i]["pathname"]) {
                menuItemEl = links[i];
                break;
            }
        }

        if (menuItemEl) {
            menuItemEl.classList.add("active");

            const parentEl = menuItemEl.parentElement;
            if (parentEl) {
                parentEl.classList.add("active");

                const parent2El = parentEl.parentElement;
                if (parent2El) {
                    parent2El.classList.add("in");
                }

                const parent3El = parent2El.parentElement;
                if (parent3El) {
                    parent3El.classList.add("active");
                    parent3El.firstChild.classList.add("active");
                }
            }
        }
    }

    /**
     * Toggles the right sidebar
     */
    toggleRightSidebar() {
        this.settingsButtonClicked.emit();
    }

    /**
     * Toggle the menu bar when having mobile screen
     */
    toggleMobileMenu(event: any) {
        console.log("clicked " + JSON.stringify(event));
        event.preventDefault();
        this.mobileMenuButtonClicked.emit();
    }

    getMenuItems() {
        // this.menuItems = this.authService.getMenuItemsForUser();
    }

    logout() {
        this.authService.logout();
        this.router.navigate(["signin"]);
    }
}
